import { AnimatePresence } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { AnimatedTab } from '../../components/animation/AnimatedTab';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import {
  BACKOFFICE_NAME,
  BACKOFFICE_NAME_CAPS,
  dateDifferenceInDaysFromToday
} from '../../helpers/helperFunctions';
import { read, store } from '../../helpers/localstorage-helper';
import { Flexed, TabSelectButton, Tabs } from '../../styles/GlobalComponents';
import Direct from './Direct/Direct';
import Generations from './Generations/Generations';
import { BackofficeNavWrapper } from './MyTeamBackoffice.styles';
import { SearchTeamMemberInput } from './SearchTeamMemberInput';
import { TeamStructure } from './Structure/TeamStructure/TeamStructure';
import { TradingStructure } from './Structure/TradingStructure/TradingStructure';
import Unilevel from './Unilevel/Unilevel';
import Volume from './Volume/Volume';
import { WarningBox } from './common/WarningBox';
import { Desktop, Mobile } from '../../App';
import styled from 'styled-components';

const SELECTED_TAB_LC_KEY = 'MY_TEAM_SELECTED_TAB_LC_KEY';

const MyTeamBackoffice = () => {
  const history = useHistory();
  const { t } = useTranslation('myTeam');

  const defaultTab = 'structure';

  const [tab, setTab] = useState(read(SELECTED_TAB_LC_KEY) ?? defaultTab);

  const [isOpen, setIsOpen] = useState(false);
  const [isTabsDropdownOpen, setIsTabsDropdownOpen] = useState(false);

  const selectTab = (tab) => {
    setTab(tab);
    store(SELECTED_TAB_LC_KEY, tab);
  };

  const { user } = useSelector((state) => state.auth.userInfo);

  const licenceIsExpired =
    dateDifferenceInDaysFromToday(user?.currentVirtualOfficeLicence?.dateEnd) ==
    0;

  useEffect(() => {
    if (licenceIsExpired) {
      setIsOpen(true);
    } else setIsOpen(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const tabs = ['structure', 'directs', 'volume', 'generations', 'unilevel'];

  const TabsMyTeamBackoffice = ({ column = false }) => {
    return (
      <div>
        <Tabs column={column}>
          {tabs.map((t) => (
            <TabSelectButton
              style={{ border: 'none' }}
              light
              key={t}
              width='220px'
              selected={t === tab}
              onClick={() => selectTab(t)}>
              <div style={{ textTransform: 'capitalize' }}>{t}</div>
            </TabSelectButton>
          ))}
        </Tabs>
        {tab === 'structure' && <SearchTeamMemberInput tab={tab} />}
      </div>
    );
  };

  return (
    <div>
      <Desktop>
        <BackofficeNavWrapper>
          <TabsMyTeamBackoffice column />
        </BackofficeNavWrapper>
      </Desktop>
      <Mobile>
        <TabsMyTeamBackoffice />
      </Mobile>

      <AnimatePresence exitBeforeEnter>
        {tab === 'structure' && (
          <AnimatedTab key={'structure'}>
            <TeamStructure tab={tab} />
          </AnimatedTab>
        )}

        {tab === 'directs' && (
          <AnimatedTab key={'direct'}>
            <Direct />
          </AnimatedTab>
        )}
        {tab === 'volume' && (
          <AnimatedTab key={'volume'}>
            <Volume tab={tab} />
          </AnimatedTab>
        )}
        {tab === 'generations' && (
          <AnimatedTab key={'generations'}>
            <Generations tab={tab} />
          </AnimatedTab>
        )}
        {tab === 'unilevel' && (
          <AnimatedTab key={'unilevel'}>
            <Unilevel tab={tab} />
          </AnimatedTab>
        )}
      </AnimatePresence>
      {/* <SidebarModal
        isOpen={isOpen}
        setOpen={setIsOpen}
        hasCloseButton={false}
        overlayClose={true}
        title={`${BACKOFFICE_NAME_CAPS}   RENEWAL`}
        sidebarWidth={'511px'}>
        <WarningBox
          text={`YOUR ${BACKOFFICE_NAME_CAPS}  SUBSCRIPTION HAS EXPIRED. RENEW THE SUBSCRIPTION NOW TO ACCESS ALL PERKS AND FEATURES.`}
          virtualOfficeButtonText={`Continue without ${BACKOFFICE_NAME} `}
          buttonText={`Purchase ${BACKOFFICE_NAME}  Subscription`}
          virtualOfficeButtonFn={() => history.push('/backoffice/dashboard')}
          buttonFn={() => history.push('/backoffice/settings/virtual-office')}
        />
      </SidebarModal> */}
    </div>
  );
};

export default MyTeamBackoffice;

export const TabsDropdown = styled.div`
  position: absolute;
  display: ${(props) => (props.open ? 'block' : 'none')};
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.01em;
  color: ${(props) => props.theme.colors.neutral900};
  background: ${(props) => props.theme.colors.neutral50};
  border-radius: 15px;
  box-shadow: ${({ theme }) => theme.shadows.shadowXS};
  cursor: pointer;
  width: 250px;
  z-index: 1;

  @media (max-width: 800px) {
  }
`;
